export default "__VITE_ASSET__CuKImN0u__"